var _path, _path2, _path3, _path4, _path5, _g, _path6, _rect, _path7, _path8, _path9, _path10, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThroughtputIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 299,
    height: 99,
    viewBox: "0 0 299 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 74H298",
    stroke: "#EEEEEE",
    strokeOpacity: 0.933333,
    strokeLinecap: "round",
    strokeDasharray: "4 4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 38H298",
    stroke: "#EEEEEE",
    strokeOpacity: 0.933333,
    strokeLinecap: "round",
    strokeDasharray: "4 4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 2H298",
    stroke: "#EEEEEE",
    strokeOpacity: 0.933333,
    strokeLinecap: "round",
    strokeDasharray: "4 4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 98H298",
    stroke: "#E4E4E4",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9 74H107.09C108.194 74 109.09 73.1046 109.09 72V59C109.09 57.8954 109.985 57 111.09 57H231",
    stroke: "url(#paint0_linear_1983_5938)",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_1983_5938)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 63,
    width: 51,
    height: 22,
    rx: 11,
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.22 78L12.04 72.34H13.3L14.21 74.94C14.49 75.73 14.65 76.22 14.88 76.98C15.08 76.28 15.31 75.58 15.53 74.94L16.45 72.34H17.65L15.51 78H14.22ZM18.4743 78V70.71H19.6643V76.97H23.6043V78H18.4743ZM24.402 78V70.71H25.592V76.97H29.532V78H24.402ZM30.3298 78V70.71H32.2398L34.1598 76.26L36.0998 70.71H37.9698V78H36.7998L36.8498 71.74L34.6398 78H33.6298L31.4698 71.75V78H30.3298Z",
    fill: "#141414"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8 38H83.6C85.8402 38 86.9603 38 87.816 37.564C88.5686 37.1805 89.1805 36.5686 89.564 35.816C90 34.9603 90 33.8402 90 31.6V8.4C90 6.15979 90 5.03968 90.436 4.18404C90.8195 3.43139 91.4314 2.81947 92.184 2.43597C93.0397 2 94.1598 2 96.4 2H242",
    stroke: "#0077E6",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 26,
    width: 81,
    height: 24,
    rx: 12,
    fill: "#2B8EEA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1643 37.3863C20.1643 36.0985 21.2307 35.2031 22.7801 35.2031C24.2691 35.2031 25.2148 36.0281 25.2551 37.3561H23.9673C23.9371 36.7223 23.4843 36.3501 22.7599 36.3501C21.9652 36.3501 21.4521 36.7324 21.4521 37.3461C21.4521 37.8692 21.7338 38.161 22.3475 38.3018L23.5045 38.5534C24.7621 38.825 25.3758 39.4689 25.3758 40.5656C25.3758 41.9338 24.3094 42.8192 22.6895 42.8192C21.12 42.8192 20.0939 41.9841 20.0637 40.6661H21.3514C21.3615 41.29 21.8646 41.6622 22.6895 41.6622C23.5447 41.6622 24.088 41.29 24.088 40.6762C24.088 40.1832 23.8365 39.8915 23.2328 39.7607L22.0658 39.4991C20.8183 39.2274 20.1643 38.5131 20.1643 37.3863ZM25.5649 40.1933C25.5649 38.654 26.5811 37.5674 28.0499 37.5674C29.4081 37.5674 30.3337 38.322 30.4645 39.5192H29.2371C29.0962 38.9558 28.6837 38.664 28.1002 38.664C27.3155 38.664 26.7923 39.2576 26.7923 40.1933C26.7923 41.129 27.2752 41.7125 28.06 41.7125C28.6737 41.7125 29.1063 41.4107 29.2371 40.8673H30.4746C30.3237 42.0244 29.3578 42.8192 28.06 42.8192C26.5509 42.8192 25.5649 41.7729 25.5649 40.1933ZM32.3641 42.8192C31.3077 42.8192 30.6638 42.2055 30.6638 41.2698C30.6638 40.3543 31.3278 39.7808 32.5049 39.6903L33.9939 39.5796V39.4689C33.9939 38.7948 33.5915 38.5232 32.9677 38.5232C32.2433 38.5232 31.8409 38.825 31.8409 39.3482H30.7946C30.7946 38.2717 31.6799 37.5674 33.0281 37.5674C34.3662 37.5674 35.1911 38.2918 35.1911 39.6701V42.6884H34.1146L34.0241 41.9539C33.8128 42.467 33.1387 42.8192 32.3641 42.8192ZM32.7665 41.8936C33.5211 41.8936 34.004 41.4408 34.004 40.6762V40.4146L32.9677 40.4951C32.2031 40.5656 31.9113 40.8171 31.9113 41.2195C31.9113 41.6722 32.2132 41.8936 32.7665 41.8936ZM37.1314 42.6884H35.9141V35.2031H37.1314V42.6884ZM40.1393 42.8192C38.6604 42.8192 37.6241 41.7427 37.6241 40.2034C37.6241 38.644 38.6403 37.5674 40.0991 37.5674C41.5881 37.5674 42.5338 38.5635 42.5338 40.1128V40.4851L38.7912 40.4951C38.8818 41.3704 39.3445 41.8131 40.1595 41.8131C40.8336 41.8131 41.2762 41.5515 41.4171 41.0787H42.554C42.3427 42.1652 41.4372 42.8192 40.1393 42.8192ZM40.1092 38.5735C39.3848 38.5735 38.9421 38.9659 38.8214 39.7104H41.3165C41.3165 39.0262 40.8436 38.5735 40.1092 38.5735ZM46.4137 36.4205C44.9549 36.4205 44.1198 37.4769 44.1198 39.0665C44.1198 40.7064 45.0655 41.6018 46.4238 41.6018C47.7015 41.6018 48.4762 40.8976 48.4762 39.7205V39.6903H46.2527V38.5534H49.6734V42.6884H48.5869L48.5064 41.8433C48.1039 42.4067 47.2689 42.799 46.2728 42.799C44.2104 42.799 42.7717 41.3 42.7717 39.0363C42.7717 36.8028 44.2305 35.2132 46.4439 35.2132C48.124 35.2132 49.4219 36.1891 49.6332 37.6882H48.2749C48.0435 36.8229 47.2991 36.4205 46.4137 36.4205ZM52.6034 42.8192C51.1245 42.8192 50.0882 41.7427 50.0882 40.2034C50.0882 38.644 51.1043 37.5674 52.5632 37.5674C54.0522 37.5674 54.9979 38.5635 54.9979 40.1128V40.4851L51.2552 40.4951C51.3458 41.3704 51.8086 41.8131 52.6235 41.8131C53.2976 41.8131 53.7403 41.5515 53.8811 41.0787H55.018C54.8067 42.1652 53.9012 42.8192 52.6034 42.8192ZM52.5732 38.5735C51.8488 38.5735 51.4062 38.9659 51.2854 39.7104H53.7805C53.7805 39.0262 53.3076 38.5735 52.5732 38.5735ZM56.7046 42.6884H55.4772V37.7183H56.6141L56.7146 38.3622C57.0265 37.8592 57.6302 37.5674 58.3043 37.5674C59.5518 37.5674 60.1957 38.3421 60.1957 39.6299V42.6884H58.9683V39.9217C58.9683 39.0866 58.5558 38.6842 57.9219 38.6842C57.1674 38.6842 56.7046 39.2074 56.7046 40.0122V42.6884ZM61.7136 42.6884H60.3755L63.0315 35.3339H64.3495L67.0058 42.6884H65.6473L65.0538 40.9881H62.3071L61.7136 42.6884ZM63.5245 37.5272L62.6895 39.9015H64.6815L63.8364 37.5272C63.776 37.336 63.7056 37.1147 63.6855 36.9638C63.6553 37.1046 63.5949 37.326 63.5245 37.5272ZM68.7124 35.3339V42.6884H67.4248V35.3339H68.7124ZM70.4837 42.8091C70.041 42.8091 69.6686 42.4469 69.6686 42.0143C69.6686 41.5717 70.041 41.2095 70.4837 41.2095C70.9264 41.2095 71.2987 41.5717 71.2987 42.0143C71.2987 42.4469 70.9264 42.8091 70.4837 42.8091Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.0047 37.1484L12.9514 39.1606L16.8981 37.1484V41.6303L12.9514 43.8557L9.0047 41.6303V37.1484Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.0047 36.8139L9.66249 36.4785L12.9514 38.1553L16.2404 36.4785L16.8981 36.8139L12.9514 38.826L9.0047 36.8139Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M9.0047 35.8071L12.9514 33.7949L16.8981 35.8071L12.9514 37.8193L9.0047 35.8071Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1983_5938",
    x: -4,
    y: 59,
    width: 59,
    height: 30,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1983_5938"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1983_5938",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1983_5938",
    x1: 9,
    y1: 65.8029,
    x2: 231,
    y2: 65.8029,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#141414"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThroughtputIllustration);
export default __webpack_public_path__ + "static/media/throughtput_illustration.4f80db300d4f9b4ecd0a404aa2b61a86.svg";
export { ForwardRef as ReactComponent };